<page-content *ngIf="!isLoading">
  <mat-card appearance="outlined" *ngIf="!myPackage.tweebie.isDestination && !myPackage.isScreenPackage">
    <mat-list>
      <mat-list-item class="fixed-height">
        <div class="full-width">
          <h4>{{'packages.detail.stcBookingLink' | translate}}</h4>
          <div *ifPrivilege="{name: 'write', value: 'packages'}" class="button-right-container">
            <button (click)="removeFromMatchIds($event, 'stcId')" class="ibexfusion-raised-button"
                    mat-button>{{'general.reset' | translate }}</button>
          </div>
          <smart-input (onChange)="addToMatchIds($event, 'stcId')" [(model)]="myPackage" jsonPointerKey="/tweebie" key="stcId"
                       translationPrefix="packages.detail"></smart-input>
        </div>
      </mat-list-item>

      <mat-list-item class="fixed-height">
        <div class="full-width">
          <h4>{{'packages.detail.changeBookingLink' | translate}}</h4>
          <div *ifPrivilege="{name: 'write', value: 'packages'}" class="button-right-container">
            <button (click)="removeFromMatchIds($event, 'bookingLink')" class="ibexfusion-raised-button"
                    mat-button>{{'general.reset' | translate }}</button>
          </div>
          <smart-input (onChange)="addToMatchIds($event, 'bookingLink')" [(model)]="myPackage" jsonPointerKey="/tweebie" key="bookingLink"
                       translationPrefix="packages.detail"></smart-input>
        </div>
      </mat-list-item>

      <mat-list-item *ngIf="myPackage.tweebie.bookingLink || myPackage.tweebie.stcId">
        <span>{{'packages.detail.bookingLink' | translate}}: </span>
        <a *ngIf="myPackage.tweebie.bookingLink" href="{{myPackage.tweebie.bookingLink}}"
           target="_blank">{{myPackage.tweebie.bookingLink}}</a>
        <a *ngIf="!myPackage.tweebie.bookingLink && myPackage.tweebie.stcId" href="{{bookingLinkBase}}{{myPackage.tweebie.stcId}}"
           target="_blank">{{bookingLinkBase}}{{myPackage.tweebie.stcId}}</a>
      </mat-list-item>
    </mat-list>

    <div (click)="readMe('packages-booking-link', 'packages')" class="button-right-container float-right">
      <button class="ibexfusion-icon-button help" mat-icon-button style="opacity: 0">
        <mat-icon>help</mat-icon>
      </button>
    </div>

    <div class="button-right-container">
      <button (click)="savePackage()" class="ibexfusion-raised-button" mat-button>{{'general.save' | translate }}</button>
    </div>
  </mat-card>
</page-content>
